// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + chunkId + "." + {"210":"bc41fc8bba9b4c3edd15","581":"12883bd8d8c3d9add8b7"}[chunkId] + ".bundle.js";
};